var _path, _rect, _rect2, _path2, _circle, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgViewTheAgreement2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 56,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.66675 14.6364C4.66675 9.71604 8.65548 5.72729 13.5758 5.72729H26.3613C28.8585 5.72729 31.2412 6.77542 32.9286 8.61629L40.1887 16.5363C41.6948 18.1794 42.5304 20.3274 42.5304 22.5564V41.3637C42.5304 46.284 38.5416 50.2728 33.6213 50.2728H13.5758C8.65548 50.2728 4.66675 46.284 4.66675 41.3637V14.6364Z",
  fill: "url(#paint0_linear_128_4935)"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20.0455,
  height: 4.45455,
  rx: 2.22727,
  transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 29.1667 22.4319)",
  fill: "url(#paint1_linear_128_4935)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 12.25,
  height: 4.45455,
  rx: 2.22727,
  transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 21.8745 30.2273)",
  fill: "url(#paint2_linear_128_4935)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.7229 15.7509C29.7231 12.8097 29.7234 7.8218 29.7227 6.28421C32.5076 7.3977 38.076 12.9659 41.2803 17.9774L31.9487 17.9774C30.7185 17.9774 29.7228 16.9811 29.7229 15.7509Z",
  fill: "url(#paint3_linear_128_4935)"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 41.4167,
  cy: 40.25,
  r: 12.25,
  fill: "url(#paint4_linear_128_4935)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.9624 40.8068L40.6346 44.3304L46.428 37.4659",
  stroke: "white",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_128_4935",
  x1: 4.66675,
  y1: 5.72729,
  x2: 39.5296,
  y2: 43.5773,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D2C6FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E1D9FE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_128_4935",
  x1: -0.00000148659,
  y1: -3.23967,
  x2: 22.023,
  y2: -0.954125,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8768F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#653CF9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_128_4935",
  x1: -9.08471e-7,
  y1: -3.23967,
  x2: 13.549,
  y2: -2.38038,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8768F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#653CF9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_128_4935",
  x1: 29.7227,
  y1: -2.21992,
  x2: 42.5506,
  y2: -1.92751,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8768F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#653CF9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_128_4935",
  x1: 31.4126,
  y1: 28,
  x2: 50.2031,
  y2: 65.0057,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7856F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2CF1FF"
})))));
export default SvgViewTheAgreement2;